// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sideBar {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 30px 1fr;
}
#sideBar #menu-bar {
  background: #252525;
  grid-row: 1;
  grid-column: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 30px 30px 30px 30px 1fr 52px 3px;
}
#sideBar #menu-bar.small {
  grid-template-columns: 0px 0px 30px 30px 1fr 52px 3px;
}
#sideBar #menu-bar #add-animation {
  grid-row: 1;
  grid-column: 1;
}
#sideBar #menu-bar #load-animation {
  grid-row: 1;
  grid-column: 2;
}
#sideBar #menu-bar #save-animation {
  grid-row: 1;
  grid-column: 3;
}
#sideBar #menu-bar #edit-animation {
  grid-row: 1;
  grid-column: 4;
}
#sideBar #menu-bar #framerate-animation {
  grid-row: 1;
  grid-column: 6;
}
#sideBar .simple-button {
  width: 80px;
  height: 20px;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
  background: #444444;
  border: 0;
  line-height: 12px;
  cursor: pointer;
  align-self: center;
  justify-self: center;
  border-radius: 0;
}
#sideBar .simple-button:active {
  transform-origin: center;
  transform: scale(0.95);
}
#sideBar #save-animation-pane {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr 40px auto;
}
#sideBar #save-animation-pane #save-animation-list {
  grid-row: 1;
  grid-column: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
#sideBar #save-animation-pane #save-animation-list .save-animation-list-entry {
  height: 20px;
  margin-left: 10px;
  display: flex;
  align-content: center;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
  line-height: 15px;
}
#sideBar #save-animation-pane #save-animation-buttons {
  grid-row: 2;
  grid-column: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 10px 1fr 10px 1fr 10px;
  align-items: center;
}
#sideBar #save-animation-pane #save-animation-buttons #save-snippet {
  grid-row: 1;
  grid-column: 2;
}
#sideBar #save-animation-pane #save-animation-buttons #save-file {
  grid-row: 1;
  grid-column: 4;
}
#sideBar #save-animation-pane #save-animation-snippet {
  grid-row: 3;
  grid-column: 1;
  width: calc(100% - 31px);
  height: 20px;
  align-content: center;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
  padding-left: 31px;
  background: #252525;
}
#sideBar #load-animation-pane {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 75px 1fr;
  grid-template-rows: 10px 20px 10px 20px 10px 20px 1fr auto;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
}
#sideBar #load-animation-pane #load-animation-snippet-id-label {
  grid-row: 2;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #load-animation-pane #load-animation-local-file-label {
  grid-row: 6;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #load-animation-pane #load-snippet-id {
  grid-row: 2;
  grid-column: 2;
  margin-right: 10px;
  border: 0;
  background: #252525;
  width: 127px;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
}
#sideBar #load-animation-pane #load-snippet {
  grid-row: 4;
  grid-column: 2;
  width: 60px;
  justify-self: left;
}
#sideBar #load-animation-pane input[type=file] {
  display: none;
}
#sideBar #load-animation-pane #file-snippet-label {
  grid-row: 6;
  grid-column: 2;
  width: 60px;
  justify-self: left;
  text-align: center;
  line-height: 18px;
}
#sideBar #load-animation-pane #load-animation-snippet {
  grid-row: 8;
  grid-column: 1/3;
  width: calc(100% - 31px);
  height: 20px;
  align-content: center;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
  padding-left: 31px;
  background: #252525;
}
#sideBar #add-animation-pane {
  grid-column: 1;
  grid-row: 2;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 75px 1fr;
  grid-template-rows: 10px 20px 10px 20px 10px 20px 10px 20px 10px 20px 10px 20px 1fr;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
}
#sideBar #add-animation-pane .input-text {
  border: 0;
  background: #252525;
  width: 127px;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
}
#sideBar #add-animation-pane .option {
  background: #252525;
  color: white;
  border: 0;
}
#sideBar #add-animation-pane #add-animation-display-name-label {
  grid-row: 2;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-mode-label {
  grid-row: 4;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-property-label {
  grid-row: 6;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-type-label {
  grid-row: 8;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-loop-mode-label {
  grid-row: 10;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-name {
  grid-row: 2;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-mode {
  grid-row: 4;
  grid-column: 2;
  margin-right: 10px;
  width: calc(100% - 10px);
}
#sideBar #add-animation-pane #add-animation-property {
  grid-row: 6;
  grid-column: 2;
  margin-right: 10px;
  width: calc(100% - 10px);
}
#sideBar #add-animation-pane #add-animation-type {
  grid-row: 8;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation-loop-mode {
  grid-row: 10;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #add-animation-pane #add-animation {
  grid-row: 12;
  grid-column: 2;
  justify-self: left;
}
#sideBar #edit-animation-pane {
  grid-column: 1;
  grid-row: 2;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 75px 1fr;
  grid-template-rows: 10px 20px 10px 20px 10px 20px 10px 20px 1fr;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
  background: #111111;
}
#sideBar #edit-animation-pane .input-text {
  border: 0;
  background: #252525;
  width: 127px;
  color: white;
  font-family: "acumin-pro-condensed";
  font-size: 10pt;
}
#sideBar #edit-animation-pane .option {
  background: #252525;
  color: white;
  border: 0;
}
#sideBar #edit-animation-pane #edit-animation-display-name-label {
  grid-row: 2;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation-property-label {
  grid-row: 4;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation-loop-mode-label {
  grid-row: 6;
  grid-column: 1;
  justify-self: end;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation-name {
  grid-row: 2;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation-property {
  grid-row: 4;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation-loop-mode {
  grid-row: 6;
  grid-column: 2;
  margin-right: 10px;
}
#sideBar #edit-animation-pane #edit-animation {
  grid-row: 8;
  grid-column: 1/3;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 100%;
}
#sideBar #edit-animation-pane #edit-animation #edit-animation-ok {
  grid-row: 1;
  grid-column: 1;
}
#sideBar #edit-animation-pane #edit-animation #edit-animation-cancel {
  grid-row: 1;
  grid-column: 2;
}
#sideBar #animation-list {
  background: #111111;
  grid-row: 2;
  grid-column: 1;
  width: 100%;
  height: 100%;
}
#sideBar #animation-list .animation-entry {
  height: 20px;
  display: grid;
  grid-template-columns: 20px 10px 1fr 20px 20px;
  grid-template-rows: 100%;
}
#sideBar #animation-list .animation-entry.isActive {
  background: #444444;
}
#sideBar #animation-list .animation-entry .animation-active-indicator {
  grid-row: 1;
  grid-column: 1;
  display: grid;
  margin: 5px;
  padding-top: 2px;
}
#sideBar #animation-list .animation-entry .animation-chevron {
  grid-row: 1;
  grid-column: 2;
  display: grid;
  align-content: center;
  padding-top: 5px;
  cursor: pointer;
}
#sideBar #animation-list .animation-entry .animation-chevron .animation-chevron-image.collapsed {
  transform-origin: 50% 50%;
  transform: rotateZ(-90deg);
}
#sideBar #animation-list .animation-entry .animation-name {
  cursor: pointer;
  grid-row: 1;
  grid-column: 3;
  font-family: "acumin-pro-condensed";
  font-size: 10.5pt;
  color: white;
  display: grid;
  align-self: center;
  margin-left: 5px;
  user-select: none;
}
#sideBar #animation-list .animation-entry .animation-options {
  grid-row: 1;
  grid-column: 4;
}
#sideBar #animation-list .animation-entry .animation-delete {
  grid-row: 1;
  grid-column: 5;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/animations/curveEditor/scss/sideBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;EACA,4BAAA;AACJ;AACI;EACI,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,uDAAA;AACR;AACQ;EACI,qDAAA;AACZ;AAEQ;EACI,WAAA;EACA,cAAA;AAAZ;AAGQ;EACI,WAAA;EACA,cAAA;AADZ;AAIQ;EACI,WAAA;EACA,cAAA;AAFZ;AAKQ;EACI,WAAA;EACA,cAAA;AAHZ;AAMQ;EACI,WAAA;EACA,cAAA;AAJZ;AAQI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AANR;AAQQ;EACI,wBAAA;EACA,sBAAA;AANZ;AAUI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,iCAAA;AARR;AAUQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AARZ;AAUY;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EAEA,mCAAA;EACA,eAAA;EACA,iBAAA;AAThB;AAaQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,6CAAA;EACA,mBAAA;AAXZ;AAaY;EACI,WAAA;EACA,cAAA;AAXhB;AAcY;EACI,WAAA;EACA,cAAA;AAZhB;AAgBQ;EACI,WAAA;EACA,cAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAdZ;AAkBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,0DAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AAhBR;AAkBQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAhBZ;AAmBQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAjBZ;AAoBQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AAlBZ;AAqBQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAnBZ;AAsBQ;EACI,aAAA;AApBZ;AAuBQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AArBZ;AAwBQ;EACI,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAtBZ;AA0BI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,mFAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AAxBR;AA0BQ;EACI,SAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AAxBZ;AA2BQ;EACI,mBAAA;EACA,YAAA;EACA,SAAA;AAzBZ;AA4BQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA1BZ;AA6BQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA3BZ;AA8BQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA5BZ;AA+BQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA7BZ;AAgCQ;EACI,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA9BZ;AAiCQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AA/BZ;AAkCQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AAhCZ;AAmCQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AAjCZ;AAoCQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AAlCZ;AAqCQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;AApCZ;AAwCI;EACI,cAAA;EACA,WAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,+DAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;AAvCR;AAyCQ;EACI,SAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;AAvCZ;AA0CQ;EACI,mBAAA;EACA,YAAA;EACA,SAAA;AAxCZ;AA2CQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAzCZ;AA4CQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA1CZ;AA6CQ;EACI,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA3CZ;AA8CQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AA5CZ;AA+CQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AA7CZ;AAgDQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AA9CZ;AAiDQ;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,wBAAA;AA/CZ;AAiDY;EACI,WAAA;EACA,cAAA;AA/ChB;AAkDY;EACI,WAAA;EACA,cAAA;AAhDhB;AAqDI;EACI,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAnDR;AAqDQ;EACI,YAAA;EACA,aAAA;EACA,8CAAA;EACA,wBAAA;AAnDZ;AAqDY;EACI,mBAAA;AAnDhB;AAsDY;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AApDhB;AAuDY;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AArDhB;AAwDoB;EACI,yBAAA;EACA,0BAAA;AAtDxB;AA2DY;EACI,eAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzDhB;AA4DY;EACI,WAAA;EACA,cAAA;AA1DhB;AA6DY;EACI,WAAA;EACA,cAAA;AA3DhB","sourcesContent":["#sideBar {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: 30px 1fr;\r\n\r\n    #menu-bar {\r\n        background: #252525;\r\n        grid-row: 1;\r\n        grid-column: 1;\r\n        width: 100%;\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 30px 30px 30px 30px 1fr 52px 3px;\r\n\r\n        &.small {\r\n            grid-template-columns: 0px 0px 30px 30px 1fr 52px 3px;\r\n        }\r\n\r\n        #add-animation {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n        }\r\n\r\n        #load-animation {\r\n            grid-row: 1;\r\n            grid-column: 2;\r\n        }\r\n\r\n        #save-animation {\r\n            grid-row: 1;\r\n            grid-column: 3;\r\n        }\r\n\r\n        #edit-animation {\r\n            grid-row: 1;\r\n            grid-column: 4;\r\n        }\r\n\r\n        #framerate-animation {\r\n            grid-row: 1;\r\n            grid-column: 6;\r\n        }\r\n    }\r\n\r\n    .simple-button {\r\n        width: 80px;\r\n        height: 20px;\r\n        color: white;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 10pt;\r\n        background: #444444;\r\n        border: 0;\r\n        line-height: 12px;\r\n        cursor: pointer;\r\n        align-self: center;\r\n        justify-self: center;\r\n        border-radius: 0;\r\n\r\n        &:active {\r\n            transform-origin: center;\r\n            transform: scale(0.95);\r\n        }\r\n    }\r\n\r\n    #save-animation-pane {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 1fr 40px auto;\r\n\r\n        #save-animation-list {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n            display: flex;\r\n            flex-direction: column;\r\n            padding-top: 5px;\r\n\r\n            .save-animation-list-entry {\r\n                height: 20px;\r\n                margin-left: 10px;\r\n                display: flex;\r\n                align-content: center;\r\n                color: white;\r\n\r\n                font-family: \"acumin-pro-condensed\";\r\n                font-size: 10pt;\r\n                line-height: 15px;\r\n            }\r\n        }\r\n\r\n        #save-animation-buttons {\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n            display: grid;\r\n            grid-template-rows: 100%;\r\n            grid-template-columns: 10px 1fr 10px 1fr 10px;\r\n            align-items: center;\r\n\r\n            #save-snippet {\r\n                grid-row: 1;\r\n                grid-column: 2;\r\n            }\r\n\r\n            #save-file {\r\n                grid-row: 1;\r\n                grid-column: 4;\r\n            }\r\n        }\r\n\r\n        #save-animation-snippet {\r\n            grid-row: 3;\r\n            grid-column: 1;\r\n            width: calc(100% - 31px);\r\n            height: 20px;\r\n            align-content: center;\r\n            color: white;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 10pt;\r\n            padding-left: 31px;\r\n            background: #252525;\r\n        }\r\n    }\r\n\r\n    #load-animation-pane {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-columns: 75px 1fr;\r\n        grid-template-rows: 10px 20px 10px 20px 10px 20px 1fr auto;\r\n        color: white;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 10pt;\r\n\r\n        #load-animation-snippet-id-label {\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #load-animation-local-file-label {\r\n            grid-row: 6;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #load-snippet-id {\r\n            grid-row: 2;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n            border: 0;\r\n            background: #252525;\r\n            width: 127px;\r\n            color: white;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 10pt;\r\n        }\r\n\r\n        #load-snippet {\r\n            grid-row: 4;\r\n            grid-column: 2;\r\n            width: 60px;\r\n            justify-self: left;\r\n        }\r\n\r\n        input[type=\"file\"] {\r\n            display: none;\r\n        }\r\n\r\n        #file-snippet-label {\r\n            grid-row: 6;\r\n            grid-column: 2;\r\n            width: 60px;\r\n            justify-self: left;\r\n            text-align: center;\r\n            line-height: 18px;\r\n        }\r\n\r\n        #load-animation-snippet {\r\n            grid-row: 8;\r\n            grid-column: 1 / 3;\r\n            width: calc(100% - 31px);\r\n            height: 20px;\r\n            align-content: center;\r\n            color: white;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 10pt;\r\n            padding-left: 31px;\r\n            background: #252525;\r\n        }\r\n    }\r\n\r\n    #add-animation-pane {\r\n        grid-column: 1;\r\n        grid-row: 2;\r\n        width: 100%;\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-columns: 75px 1fr;\r\n        grid-template-rows: 10px 20px 10px 20px 10px 20px 10px 20px 10px 20px 10px 20px 1fr;\r\n        color: white;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 10pt;\r\n\r\n        .input-text {\r\n            border: 0;\r\n            background: #252525;\r\n            width: 127px;\r\n            color: white;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 10pt;\r\n        }\r\n\r\n        .option {\r\n            background: #252525;\r\n            color: white;\r\n            border: 0;\r\n        }\r\n\r\n        #add-animation-display-name-label {\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-mode-label {\r\n            grid-row: 4;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-property-label {\r\n            grid-row: 6;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-type-label {\r\n            grid-row: 8;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-loop-mode-label {\r\n            grid-row: 10;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-name {\r\n            grid-row: 2;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-mode {\r\n            grid-row: 4;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n            width: calc(100% - 10px);\r\n        }\r\n\r\n        #add-animation-property {\r\n            grid-row: 6;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n            width: calc(100% - 10px);\r\n        }\r\n\r\n        #add-animation-type {\r\n            grid-row: 8;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation-loop-mode {\r\n            grid-row: 10;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #add-animation {\r\n            grid-row: 12;\r\n            grid-column: 2;\r\n            justify-self: left;\r\n        }\r\n    }\r\n\r\n    #edit-animation-pane {\r\n        grid-column: 1;\r\n        grid-row: 2;\r\n\r\n        width: 100%;\r\n        height: 100%;\r\n        display: grid;\r\n        grid-template-columns: 75px 1fr;\r\n        grid-template-rows: 10px 20px 10px 20px 10px 20px 10px 20px 1fr;\r\n        color: white;\r\n        font-family: \"acumin-pro-condensed\";\r\n        font-size: 10pt;\r\n        background: #111111;\r\n\r\n        .input-text {\r\n            border: 0;\r\n            background: #252525;\r\n            width: 127px;\r\n            color: white;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 10pt;\r\n        }\r\n\r\n        .option {\r\n            background: #252525;\r\n            color: white;\r\n            border: 0;\r\n        }\r\n\r\n        #edit-animation-display-name-label {\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation-property-label {\r\n            grid-row: 4;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation-loop-mode-label {\r\n            grid-row: 6;\r\n            grid-column: 1;\r\n            justify-self: end;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation-name {\r\n            grid-row: 2;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation-property {\r\n            grid-row: 4;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation-loop-mode {\r\n            grid-row: 6;\r\n            grid-column: 2;\r\n            margin-right: 10px;\r\n        }\r\n\r\n        #edit-animation {\r\n            grid-row: 8;\r\n            grid-column: 1 / 3;\r\n            display: grid;\r\n            grid-template-columns: 50% 50%;\r\n            grid-template-rows: 100%;\r\n\r\n            #edit-animation-ok {\r\n                grid-row: 1;\r\n                grid-column: 1;\r\n            }\r\n\r\n            #edit-animation-cancel {\r\n                grid-row: 1;\r\n                grid-column: 2;\r\n            }\r\n        }\r\n    }\r\n\r\n    #animation-list {\r\n        background: #111111;\r\n        grid-row: 2;\r\n        grid-column: 1;\r\n        width: 100%;\r\n        height: 100%;\r\n\r\n        .animation-entry {\r\n            height: 20px;\r\n            display: grid;\r\n            grid-template-columns: 20px 10px 1fr 20px 20px;\r\n            grid-template-rows: 100%;\r\n\r\n            &.isActive {\r\n                background: #444444;\r\n            }\r\n\r\n            .animation-active-indicator {\r\n                grid-row: 1;\r\n                grid-column: 1;\r\n                display: grid;\r\n                margin: 5px;\r\n                padding-top: 2px;\r\n            }\r\n\r\n            .animation-chevron {\r\n                grid-row: 1;\r\n                grid-column: 2;\r\n                display: grid;\r\n                align-content: center;\r\n                padding-top: 5px;\r\n                cursor: pointer;\r\n\r\n                .animation-chevron-image {\r\n                    &.collapsed {\r\n                        transform-origin: 50% 50%;\r\n                        transform: rotateZ(-90deg);\r\n                    }\r\n                }\r\n            }\r\n\r\n            .animation-name {\r\n                cursor: pointer;\r\n                grid-row: 1;\r\n                grid-column: 3;\r\n                font-family: \"acumin-pro-condensed\";\r\n                font-size: 10.5pt;\r\n                color: white;\r\n                display: grid;\r\n                align-self: center;\r\n                margin-left: 5px;\r\n                user-select: none;\r\n            }\r\n\r\n            .animation-options {\r\n                grid-row: 1;\r\n                grid-column: 4;\r\n            }\r\n\r\n            .animation-delete {\r\n                grid-row: 1;\r\n                grid-column: 5;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
